var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVobbSymbolLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 346,
    viewBox: "0 0 346 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.85 0C77.39 0 0 77.39 0 172.85C0 268.31 77.39 345.7 172.85 345.7C268.31 345.7 345.7 268.31 345.7 172.85C345.7 77.39 268.31 0 172.85 0ZM172.85 317.76C92.82 317.76 27.94 252.88 27.94 172.85C27.94 92.82 92.81 27.93 172.85 27.93C252.89 27.93 317.76 92.81 317.76 172.84C317.76 252.87 252.88 317.75 172.85 317.75V317.76Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.85 41.9C100.53 41.9 41.9102 100.52 41.9102 172.84C41.9102 245.16 100.54 303.78 172.85 303.78C245.16 303.78 303.79 245.15 303.79 172.84C303.79 100.53 245.16 41.9 172.85 41.9ZM172.85 275.85C115.96 275.85 69.8402 229.73 69.8402 172.84C69.8402 115.95 115.96 69.83 172.85 69.83C229.74 69.83 275.86 115.95 275.86 172.84C275.86 229.73 229.74 275.85 172.85 275.85V275.85Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.85 83.8C123.67 83.8 83.8101 123.66 83.8101 172.84C83.8101 222.02 123.67 261.88 172.85 261.88C222.03 261.88 261.89 222.01 261.89 172.84C261.89 123.67 222.03 83.8 172.85 83.8V83.8ZM172.85 233.95C139.1 233.95 111.74 206.59 111.74 172.84C111.74 139.09 139.1 111.73 172.85 111.73C206.6 111.73 233.96 139.09 233.96 172.84C233.96 206.59 206.6 233.95 172.85 233.95V233.95Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.99 172.85C219.99 198.88 198.88 219.99 172.85 219.99C146.82 219.99 125.71 198.89 125.71 172.85C125.71 146.81 146.82 125.71 172.85 125.71C198.88 125.71 219.99 146.82 219.99 172.85V172.85Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVobbSymbolLight);
export default __webpack_public_path__ + "static/media/vobbSymbolLight.3373a662.svg";
export { ForwardRef as ReactComponent };